import { FaDiscord } from "react-icons/fa";
import styles from "./Footer.module.css";
import { Link } from "react-router-dom";

function Footer() {
    return (
        <div className={styles.content}>
            <div className={styles.footer}>
                <div className={styles.divide}>
                    <div className={styles.left}>
                        <div className={styles.loja}>
                            <h2>Eclipse Bots</h2>
                            <p>Os melhores bots para o seu servidor Discord. 🚀</p>
                        </div>
                    </div>
                    <div className={styles.right}>
                        <div className={styles.column}>
                            <div className={styles.title}>
                                Links Úteis
                            </div>
                            <div className={styles.divider}></div>
                            <div className={styles.topics}>

                                <Link to={"/"} className={styles.topic}>
                                    <div className={styles.topic}>
                                        Inicio
                                    </div>
                                </Link>

                                <Link to={"/planos"} className={styles.topic}>
                                    <div className={styles.topic}>
                                        Planos
                                    </div>
                                </Link>

                                <Link to={"/login"} className={styles.topic}>
                                    <div className={styles.topic}>
                                        Login
                                    </div>
                                </Link>
                            </div>
                        </div>
                        <div className={styles.column}>
                            <div className={styles.title}>
                                Contactos
                            </div>
                            <div className={styles.divider}></div>
                            <div className={styles.topics}>
                                <div className={styles.topic}>
                                    <Link to={"https://eclipsebots.com/discord"} className={styles.topic}>
                                        <FaDiscord /> Discord
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.reserved}>
                    <div className={styles.divider}></div>
                    Eclipse Bots 2025 © Todos os direitos reservados
                    <br />Desenvolvido por Aromiic
                </div>
            </div>
        </div>
    )
}

export default Footer;